<style  scoped>
#appstart
{
  width: 100vw;
}

#appstart:after
{
    content: "";
    position: fixed;
    top: 0;
    left: 0;
    font-size: 0;
    font-family: Blender Pro;
}

body
{
  -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    text-size-adjust: 100%;
}

.langs  li
{
    font-size:18px;
     height:50px;
 }
.logo{
	position: absolute;
	top: 15%;
	left: 65%;
	width: 250px;
	/*height: 41px;*/
	margin-top: -20px;
	opacity: 0;
	transition: opacity .8s;
	will-change: opacity
}




@media (max-width:767px)
{
  .content
  {
      position: relative;
      top: auto;
      right: auto;
      bottom: auto;
      left: auto;
      padding-top: 45vh;
      padding-left: 50px;
      padding-right: 50px;
  }
}

.logo.is-visible {
	opacity: 1
}

.canvas
 {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
}
.page-home
{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.page{
    opacity: 1;
    transition: opacity .3s;
}

.gradient-top
{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 140px;
    background-image: linear-gradient(180deg,rgba(5,7,15,.5),rgba(5,7,15,0));
    pointer-events: none;
}

.gradient-bottom{
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 140px;
    background-image: linear-gradient(0deg,rgba(5,7,15,.7),rgba(5,7,15,0));
    pointer-events: none;
}

.top-background
 {
    display: none;
    position: fixed;
    right: 0;
    top: 0;
    left: 0;
    height: 75px;
    background: #0f0f18;
    transition: opacity .3s;
    opacity: 0;
    z-index: 2;
}

.loader{
    position: absolute;
    top: 50%;
    width: 200px;
    right: 0;
    opacity: 0;
    transition: opacity .5s .5s;
    will-change: opacity;
}

.content {
    display: -ms-flexbox;
    display: flex;
    position: absolute;
    top: 0;
    right: 200px;
    bottom: 0;
    left: 65%;
    -ms-flex-direction: column;
    flex-direction: column;
    -ms-flex-pack: center;
    justify-content: center;
    padding-top: 20px;
}
.title {
    font-size: 20px;
    font-size:calc(20px + 22 * (50vw + 50vh - 2000px) /2000);
    font-family: 'Aquawax light';
    font-style: normal;
    font-weight: normal;
    text-transform: uppercase;
    line-height: 1.2em;
    letter-spacing: .1em;
    margin-bottom: 1em;
}


@media (max-width:1800px)
{
	.title {
		font-size: 40px;
		line-height: 1.1em;
		margin-bottom: .5em
	}
}



@media (max-width:1023px)
{
	.title {
		font-size: 30px
	}
}
@media (max-width:1199px)
{
	.title {
		line-height: 1em;
		font-size: 35px
	}
}
@media (max-width:767px)
{
	.title {
		letter-spacing: .9em
	}
}

@media (max-width:579px)
{
	.title {
		letter-spacing: .9em
	}

}



.main-logo {
	display: inline-block;
	position: fixed;
	bottom: 40px;
	left: 50px;
	height: 41px;
	width: 128px;
	opacity: 1;
	transition: opacity .3s;
	z-index: 2
}



@media (max-width:1023px) {
	.main-logo {
		bottom: 18px;
		left: 30px
	}
}

@media (max-width:579px) {
	.main-logo {
		top: 15px;
		bottom: auto
	}
}

.main-logo.v-enter,
.main-logo.v-leave-to {
	opacity: 0
}

.langs{
	display: inline-block;
	vertical-align: middle
}

@media (max-width:579px)
{
	.langs{
		
		height: 100%
	}
}

.langs .lang{
	opacity: 1
}

.langs .lang:not(:last-child):after {
	content: ".";
	display: inline-block;
	margin-left: 8px;
	margin-right: 0;
	color: #8e8e8e
}


@media (max-width:579px)
{

	.langs .lang
  {
		display: -ms-flexbox;
		display: flex;
		-ms-flex-pack: center;
		justify-content: center;
		-ms-flex-align: center;
		align-items: center;
		height: 100%;
		padding-left: 20px;
		padding-right: 20px;
		border-right: 1px solid hsla(0, 0%, 100%, .05)
	}
  .langs .lang:not(:last-child):after
  {
		display: none
	}
}

@media (max-width:440px)
{
	.title {
		letter-spacing: .9em
	}

}

.langs .lang.active .label,
.langs .lang:hover .label{
	opacity: 0.5

}

.langs .lang .label{
	opacity: 1;
	transition: opacity .1s;
	will-change: opacity;
  color:#1d1d1b;
}

.content {
	display: -ms-flexbox;
	display: flex;
	position: absolute;
	top: 0;
	right: 200px;
	bottom: 0;
	left: 65%;
	-ms-flex-direction: column;
	flex-direction: column;
	-ms-flex-pack: center;
	justify-content: center;
	padding-top: 20px
}

@media (max-width:1599px)
 {
	.content {
		right: 0px;
		left: 66%
	}
}

@media (max-width:1199px)
 {
   .logo-Intro img
   {
     width:350px;
   }
   .content {
 		right: 0px;
 		left: 65%
 	}
}
@media (max-width:890px)
 {
   .logo-Intro img
   {
     width:300px;
   }
   .content {
 		right: 0px;
 		left: 60%
 	}
}
@media (max-width:770px)
{
  .content {
            right: 0px;
           left: 55%;
        }
}

@media (max-width:767px)
{
	.content
  {
		position: absolute;
    width:100%;
    margin:0 auto;
		top: auto;
		right: auto;
		bottom: auto;
		left: auto;
		padding-top: 70vh;
		padding-left: 90px;
		padding-right: 50px
	}

  .content {
		padding-left: 50px;
		padding-right: 30px;
    padding-top:45vh;
	}
  .auto-height{
    height:auto;
  }
}
@media (max-width:720px)
{
  .content {
            right: 0px;
           left:0;
        }
}
@media (max-width:579px)
{
  .logo-Intro img
  {
    width:200px;
  }
	.content {
		padding-left: 40px;
		padding-right: 40px
	}
}



@media (max-width:440px)
{
  
	.content {
		padding-left: 50px;
		padding-right: 30px;
    padding-top:45vh;
	}
  .auto-height{
    height:auto;
  }
}

@media (max-width:374px)
{
	.content {
		padding-left: 20px;
		padding-right: 30px
	}
}

.content p {
	margin-bottom: 0
}

</style>

<template>

  <div class="c-loader-intro u-fixed u-pos-tl u-viewport-fit-h u-bg--brand-dark u-fit-w" >
    <div class="c-loader-intro__bar c-loader-intro__bar--x u-absolute u-pos-tl u-fit-w" :style="stylesComputed"></div>
    <div class="c-loader-intro__bar c-loader-intro__bar--y u-absolute u-pos-tr u-fit-h" :style="stylesComputed2"></div>
    <div class="c-loader-intro__bar c-loader-intro__bar--x u-absolute u-pos-bl u-fit-w" :style="stylesComputed"></div>
    <div class="c-loader-intro__bar c-loader-intro__bar--y u-absolute u-pos-tl u-fit-h" :style="stylesComputed2"></div>
  <div class="experience">
     <!-- <img src="/static/HeadImages/FirstPageImageandanimation-gray3.jpg" class="canvas" />-->

  <!-- <canvas class="canvas"></canvas>-->
     <div  class="loader"  ref="loader"   :class="{'is-visible':loaderVisible}" >
          <div  class="background"  ></div>
           <div  class="stroke" ref="loaderStroke">  </div>
           <div  class="label">Loading, please wait</div>
      </div>

    </div>
    <div class="o-wrapper--valign u-fit auto-height u-pad-r-intro-w3of12" >
      <div class="u-inline-block u-valign-middle logo-Intro">
        <img src="/static/HeadImages/Logo--Sl---bgwhite---start.png"  />
      </div>
      
   </div>
<div class="page-container" style="z-index:10">
<div  class="page-home page">
<div  class="content">
  <div  class="inner">
    <!--<h1 class="t-h2 t-text--base-bold  t-text-lh--md u-color--white u-marg-b-xl" >Best quality is not an option for us. It is our trademark!</h1>-->


    <!--<app-push-button :visible="isButtonVisible" :isIntro="!0" :active="isButtonActive" :to="{ name: 'aboutmarineholdings'}" :text="uiexplore" >{{uiexplore}}</app-push-button>-->

        <ul  class="langs" >
          <li>
            <button   style="background:transparent;border:0px; outline:none;"   class="lang">
                <span  class="label" style="color:#d93746">Loading, please wait</span>
            </button>
         </li>
          <li>
            <button   style="background:transparent;border:0px; outline:none;"   class="lang">
                <span  class="label">Traiteur (Catering)</span>
            </button>
         </li>
         <li>
          <button  style="background:transparent;border:0px; outline:none;"   class="lang">
              <span  class="label">Gourmet Grocery Store</span>
          </button>
        </li>
        <li>
          <button   style="background:transparent;border:0px; outline:none;"   class="lang">
              <span  class="label">Salameh Chicken</span>
          </button >
        </li>
        <li>
          <button  style="background:transparent;border:0px; outline:none;" @click="onMouseclick"  class="lang">
              <span  class="label">Food Safety Department </span>
          </button>
        </li>
        </ul>


         <!--<div  class="description"  :class="{'is-visible':isDescriptionVisible}">
           <p v-html="description" ></p>
         </div>-->
       </div>
     </div>
   </div>
</div>
<!--<div  class="gradient-top"></div>
<div   class="gradient-bottom"></div>
<div   class="top-background" :class="{'visible':topBackgroundVisible}"></div>
-->
</div>
</template>
<script>



//import appAnimatedText from '../app-animated-text/index.vue'
//import appPushButton from '../app-push-button/index.vue'
//import appFooterone from '../app-footer1/index.vue'
import {clamp}  from '../../utilities/clamp'
import {cubicu} from '../../utilities/cubicu'

export default
{
  name: "app-intro-loader",
  components:
  {
                  //"app-animated-text": appAnimatedText,
                //  "app-push-button": appPushButton,
                //  "app-footer-one": appFooterone
    },

  props:
   {
    debug: {
        type: Boolean,
        default: !0
    },
      assets: {
          type: Array,
          default: function() {}
      }
  },


    data: function()
    {
        return {
            percentAssetsLoaded:0,
            minLoop:0,
            isAssetsLoaded: !1,

            isLogoVisible: !1,
            isTitleVisible: !1,
            isButtonVisible: !1,
            isButtonActive: !1,
            isDescriptionVisible: !1,
            topBackgroundVisible: !1,

            title:"",
            description:"",
            uiexplore:"Enter",

            isrendererstart:!1,

            loaderVisible: !0,
            messageActive: !1
          }
    },
    computed:
    {

        pageTransitionDuration: function ()
         {
            var e = 1e3;
           return {
                leave: e,
                enter: e
            }
        },
        stylesComputed: function() {


            return {
                transform: 'scaleY(' + (1 - this.percentAssetsLoaded) + ') translateZ(0)'

            };
        },
        stylesComputed2: function() {


            return {
                transform: 'scaleX(' + (1 - this.percentAssetsLoaded) + ') translateZ(0)'

            };
        },
        stylesHeight1: function() {
            return {
              height:this.navOffsetTop+"px"

            };
        },
        stylesHeight2: function() {
            return {
                height:$root.winHeight/(12-25)+"px"

            };
        },
        stylesHeight3Bottom: function() {
            return {
                height:$root.winHeight/(12-25)+"px",
                bottom:$root.winHeight/(12+70)+"px"

            };
        }
    },
    created: function()
    {
            this.loader = {},
            this.loader.$container = this.$refs.loader,
            this.loader.$stroke = this.$refs.loaderStroke,
            this.vpw = this.$root.winWidth,
            this.vph = this.$root.winHeight,
            this.orientation="landscape",
            this.isresourcesLoaded=!1,

            this._inAnimRatio = 0,
            this._outAnimRatio = 0,
            this._currInAnimRatio = 0,
            this._currOutAnimRatio = 0,
            this.animAlphaRatio=0,

            this._sceneWidth = 1600,
            this._sceneHeight = 900,

            this._nbAssetsToLoad = 0,
            this._loaderIndex = 0,

          //  this.eventHub.$on("animate:biglogo", this.onAnimateBiglog),
            this.eventHub.$on("loader:progress", this.onLoaderProgress),
            this.eventHub.$on("loader:start", this.onLoaderStart),

          this.onResize = this.onResize.bind(this)//,
          //this.onEnterframe = this.onEnterframe.bind(this),
          //this.eventHub.$on("resize", this.onResize),
          //this.eventHub.$on("enterframe", this.onEnterframe)
    },
    mounted: function()
    {
        var t = this;


        t.loadTextures();

        this.$el.classList.add("is-assets-loading")//,

        //setTimeout(function() {t.isTitleVisible = !0}, 2e3),
        //setTimeout(function() {t.isButtonVisible = !0}, 120),
        //setTimeout(function() {t.isButtonActive = !0}, 3e3),
        //setTimeout(function() {t.isLogoVisible = !0}, 3900),
        //setTimeout(function() {t.isDescriptionVisible = !0}, 3900)

              ///////////////old//////////////////////////////
            setTimeout(function() {
                t.onTransitionLoop()
            }, 10) 
            /////////////////////////////////////////////
    },
    destroyed: function()
    {

      //  this.eventHub.$off("animate:biglogo", this.onAnimateBiglog),
        this.eventHub.$off("loader:progress", this.onLoaderProgress),
        this.eventHub.$off("loader:start", this.onLoaderStart),
        this.eventHub.$off("resize", this.onResize)//,
      //  this.eventHub.$off("enterframe", this.onEnterframe),
      //  this._stage.destroy(!0)
    },
    methods:
    {
        onMouseclick:function(e)
        {
          this.eventHub.$emit("assets:loaded");
        },
        onAnimateBiglog:function()
       {
         console.log("this._inAnimRatio"+this._inAnimRatio);
          this._inAnimRatio=!0;
        },

        loadTextures: function()
        {
            this.isresourcesLoaded=!0;

        },
      onResize: function()
      {


      },
       onPageEnter: function ()
      {
          window.scrollTo(0, 0)//,

      },
        onLoaderStart: function(t)
        {
            
            this._nbAssetsToLoad += t
        },
        onLoaderProgress: function()
        {
            this._loaderIndex += 1,
            this.percentAssetsLoaded = this._loaderIndex / this._nbAssetsToLoad,
             1 === this.percentAssetsLoaded && (this.isAssetsLoaded = !0)
        },
        onTransitionLoop: function()
        {
          var t = this;
            clearTimeout(e, n), this._loopIndex += 1;
            this.$el.classList.add("is-loop");
            var e = setTimeout(function() {
                    t.$el.classList.remove("is-loop")
                }, 1500),
                /*n = setTimeout(function() {

                    !t.isAssetsLoaded || t._loopIndex < t.minLoop ? t.onTransitionLoop() : (t.$el.classList.add("is-assets-loaded"), t.eventHub.$emit("assets:loaded"))
                }, 2700)*/
                n = setTimeout(function() {

                    !t.isAssetsLoaded || t._loopIndex < t.minLoop ? t.onTransitionLoop() : (t.eventHub.$emit("assets:loaded"))
                }, 2700)
        }
    }


}

</script>
